module.exports = __webpack_public_path__ + "db46f60a867388e19e52010498742487.svg";